{{#> elements/_dt}}
  {{> elements/_label }}
{{/elements/_dt}}
<dd>
  {{> elements/_input type="text" }}
</dd>
